/* Site-Specific JavaScript */
AOS.init({
    duration: 1000, // values from 0 to 3000, with step 50ms
    once: true, // whether animation should happen only once - while scrolling down
});

jq('.country-select select').change(function(e){
    var picked = jq(this).val();
    if (jq(this).val() != 'United States') {
        jq('.state-select').hide();
    } else {
        jq('.state-select').show();
    }
});
jq('.announcement-picker').change(function(e){
    var current = jq(this).val();
    jq('.announcement-pane').removeClass('show active');
    jq('#' + current).addClass('show active');
});
jq('.collapse-element a').click( function(e) {
    jq('.collapse').collapse('hide');
});

jq(document).ready(function () {
    if(window.location.hash) {
        var hash = window.location.hash.substring(1);
        if (hash) {
            jq('.btn.eq-dialog').each(function() {
                if (jq(this).attr('href') == '#' + hash) {
                    jq(this).click();
                    return false;
                }
            });
        }
    }
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        document.body.classList.add('brwsr-safari');
    }
    //State Popup
    //Modified to use current eqDialog library for accessibility
    var $statePopup = jq('#statePopup');
    var statePopupCookieName = "eqStateAnnouncement";
    
    if ($statePopup.length) {
        var statePopupCookie = Cookies.get(statePopupCookieName);
        if (!statePopupCookie) {
            const eqDialog = new EqDialog({
                'show_close_button' : false
            });
    
            // Build the dialog without showing it. eqDialog.open() calls
            // showModal() immediately, which moves focus before we can name the
            // dialog, so screen readers announce an unnamed dialog.
            const dialog = eqDialog.create_dialog({
                dialog_type: 'inline',
                dialog_id: 'statePopup',
                src: '',
                img_alt: '',
                close_button_text: ''
            });
            const $dialog = jq(dialog);
            
            // Find the state select element
            const $stateSelect = $dialog.find("select[name*='state'], select[id*='state']");
            
            // Append "-1" to name and id attributes
            $stateSelect.attr("name", function(i, val) {
                return val ? val + "-1" : val;
            }).attr("id", function(i, val) {
                return val ? val + "-1" : val;
            });
            
            // Append "-1" to the associated label's `for` attribute
            const stateSelectId = $stateSelect.attr("id");
            if (stateSelectId) {
                $dialog.find("label[for='" + stateSelectId.replace("-1", "") + "']")
                    .attr("for", stateSelectId);
            }
            
            // Add the ID 'statePopup' to the dialog element
            $dialog.attr('id', 'statePopupDialog');
            $dialog.attr('aria-labelledby', 'state-popup-title');
    
            // Set up a click event listener on the submit button within the dialog
            $dialog.on('click', '.submit-btn', function() {
                const selectField = $dialog.find('select');
                let stateValue = selectField.val();
                if (stateValue !== '0') {
                    // Set the cookie with the selected state value
                    Cookies.set(statePopupCookieName, stateValue, { secure: true, domain: window.location.hostname, expires: 1 });
    
                    // Close the dialog
                    dialog.close();
    
                    // Reload the page
                    document.location.reload();
                } else {
                    alert('Please fill out all fields');
                }
            });
            
            dialog.showModal();
            
            // showModal() lands on the first link in the notice, so send focus
            // to the heading to start the screen reader at the top
            $dialog.find('#state-popup-title').trigger('focus');
        }
    }
    
    function validateContactForm($form) {
        var isValid = true;
        $form.find('.required').each(function() {
            if (jq(this).val().trim() === '') {
                isValid = false;
                jq(this).addClass('error');
            } else {
                jq(this).removeClass('error');
            }
        });
        return isValid;
    }

    jq('.open-dialog-form').on('click', function(e) {
        e.preventDefault();
        const eqContactDialog = new EqDialog();

        var formID = jq(this).attr('href').substring(1);

        // Open the contact form dialog
        eqContactDialog.open('inline', formID);

        // Access the current dialog
        const $dialog = jq(eqContactDialog.currentDialog);
        const $contactForm = $dialog.find('#contact-form-investor');

        // Set up the form submission handler
        $contactForm.on('submit', function(event) {
            event.preventDefault();
            if (validateContactForm($contactForm)) {
                // Form is valid, proceed with submission
                $contactForm.off('submit').submit();
            } else {
                // Form is invalid, show an error message
                alert('Please fill out all required fields.');
            }
        });
    });
    
    // module-companies-table
    jq('.module-companies-table .pagination-wrapper .page-link').each(function() {
        const href = jq(this).attr('href');
        if(!href) return;
        try {
            const url = new URL(href);
            url.hash = 'company_table_container_start';
            jq(this).attr('href', url.href);    
        } catch(e) {}
        
    });
       
});

// Metrics - Class Stats Selector 
// Controls show/hide of content based on selected dropdown value
// Sets active tab class upon selected option change 
// -- Client wanted the same year tab active after selecting a new Class from dropdown 
if (jq('#class_selector').length) {
    // Get the default value of the dropdown option
    var currentValue = jq("#class_selector").val();
    // Variable to store the active Bootstrap tab upon dropdown change
    var activeTab;
    
    jq(document).ready(function(){
        // Find element with matching currentValue
        jq(".stats-wrapper[data-class-id='" + currentValue + "']").show();
        // Hide all other stats-wrapper
        jq(".stats-wrapper:not([data-class-id='" + currentValue + "'])").hide();
        // Set value of active bootstrap tab
        activeTab = jq(".nav-link.active").data('year');
        // Keep the Year dropdown in sync with the active year tab
        jq("#year_selector").val(activeTab);
    });
    
    // Update the activeTab variable when a new tab is selected
    jq('button[data-toggle="tab"]').on('shown.bs.tab', function (event) {
        activeTab = jq(event.target).data('year'); // newly activated tab
    })
    
    // Listen for change on class_selector to show/hide stats-wrapper
    jq("#class_selector").change(function(){
        var newValue = jq(this).val();
        // Find element with matching currentValue
        jq(".stats-wrapper[data-class-id='" + newValue + "']").show();
        // Hide all other stats-wrapper
        jq(".stats-wrapper:not([data-class-id='" + newValue + "'])").hide();
        
        // Compare activeTab value to new visible tabs and add Active class if it matches
        // Scope to the visible class group instead of :visible on the links, since the
        // year tabs are hidden when the years render as a dropdown
        var newTabs = jq(".stats-wrapper:visible").find(".nav-link");
        // Not every class has a record for every year (e.g. Class S has no 2022), so fall
        // back to the first available year rather than leaving every panel hidden
        var matchedTab = newTabs.filter('[data-year="' + activeTab + '"]');
        if (!matchedTab.length) {
            activeTab = newTabs.first().data('year');
            jq("#year_selector").val(activeTab);
        }
        jq(newTabs).each(function() {
            // Get target to properly show/hide the tab-content
            var target = jq(this).data('target');
            if(jq(this).data('year') === activeTab) {
                jq(this).addClass('active');
                jq(this).attr('aria-selected', 'true');
                jq(target).tab('show');
            } else {
                jq(this).removeClass('active');
                jq(this).attr('aria-selected', 'false');
                jq(target).removeClass('show active');
            }
        });
    }); 
}

// Metrics - Year Selector
// Years render as a dropdown instead of tabs; selecting a year activates the matching
// tab inside the class group that is currently visible.
if (jq('#year_selector').length) {
    jq('#year_selector').change(function () {
        var selectedYear = jq(this).val();
        var visibleTabs = jq('.stats-wrapper:visible').find('.nav-link');
        var match = visibleTabs.filter('[data-year="' + selectedYear + '"]');
        // Fall back to the first year if this class has no record for the chosen year,
        // keeping the dropdown in sync with the year actually shown
        if (!match.length) {
            match = visibleTabs.first();
            jq(this).val(match.data('year'));
        }
        // Trigger the tab so Bootstrap's shown.bs.tab keeps activeTab current
        match.first().trigger('click');
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    const form = document.querySelector('form');  // Ensure we're targeting the correct form

    dropdownToggles.forEach(toggle => {
        const key = toggle.id.split('-')[1];  // Extract the filter key, like 'industry' or 'investment_type'
        const menu = document.getElementById(`dropdownMenu-${key}`);

        // Read URL parameters and set the dropdown label
        const urlParams = new URLSearchParams(window.location.search);
        const selectedOptions = urlParams.getAll(`${key}[]`); // Adjusted for multiple selections

        if (selectedOptions.length > 0) {
            updateToggleLabel(toggle, selectedOptions);
            checkSelectedOptions(menu, selectedOptions);
        }

        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown(toggle, menu);
        });

        toggle.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleDropdown(toggle, menu);
            } else if (event.key === 'Escape') {
                event.preventDefault();
                closeDropdown(toggle, menu);
                toggle.focus(); // Return focus to the toggle button
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (toggle.getAttribute('aria-expanded') === 'false') {
                    toggleDropdown(toggle, menu);
                }
                // Focus first checkbox directly
                const firstCheckbox = menu.querySelector('input[type="checkbox"]');
                if (firstCheckbox) {
                    firstCheckbox.focus();
                }
            }
        });

        // Handle ESC key on the dropdown menu itself
        menu.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                closeDropdown(toggle, menu);
                toggle.focus(); // Return focus to the toggle button
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                const currentCheckbox = event.target.closest('input[type="checkbox"]');
                const nextCheckbox = currentCheckbox ? currentCheckbox.parentElement.nextElementSibling?.querySelector('input[type="checkbox"]') : menu.querySelector('input[type="checkbox"]');
                if (nextCheckbox) {
                    nextCheckbox.focus();
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                const currentCheckbox = event.target.closest('input[type="checkbox"]');
                const prevCheckbox = currentCheckbox ? currentCheckbox.parentElement.previousElementSibling?.querySelector('input[type="checkbox"]') : null;
                if (prevCheckbox) {
                    prevCheckbox.focus();
                } else {
                    toggle.focus(); // Return to combobox when reaching the top
                }
            } else if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                const currentCheckbox = event.target.closest('input[type="checkbox"]');
                if (currentCheckbox) {
                    currentCheckbox.checked = !currentCheckbox.checked;
                    currentCheckbox.dispatchEvent(new Event('change'));
                    // Update aria-checked attribute on the parent li
                    const optionElement = currentCheckbox.closest('li[role="option"]');
                    if (optionElement) {
                        optionElement.setAttribute('aria-checked', currentCheckbox.checked.toString());
                    }
                }
            }
        });

        // Fix the document click handler to not close when clicking inside the dropdown
        document.addEventListener('click', function(event) {
            if (!toggle.contains(event.target) && !menu.contains(event.target)) {
                closeDropdown(toggle, menu);
            }
        });

        const checkboxes = menu.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function(e) {
                e.stopPropagation(); // Prevent event bubbling
                const selectedOptions = [];
                const optionElement = checkbox.closest('li[role="option"]');
                
                // Update aria-checked attribute
                if (optionElement) {
                    optionElement.setAttribute('aria-checked', checkbox.checked.toString());
                }
                
                checkboxes.forEach(box => {
                    if (box.checked) {
                        selectedOptions.push(box.value);
                    }
                });
                updateToggleLabel(toggle, selectedOptions);
            });

            // Add click handler to prevent dropdown from closing when clicking checkboxes
            checkbox.addEventListener('click', function(e) {
                e.stopPropagation();
            });

            // Handle ESC key on individual checkboxes
            checkbox.addEventListener('keydown', function(event) {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    closeDropdown(toggle, menu);
                    toggle.focus(); // Return focus to the toggle button
                }
            });
        });

        // Make checkboxes focusable and remove tabindex from li elements
        const optionElements = menu.querySelectorAll('li[role="option"]');
        optionElements.forEach(option => {
            option.removeAttribute('tabindex'); // Remove tabindex from li elements
        });
        
        // Ensure checkboxes are focusable (they should be by default, but let's be explicit)
        checkboxes.forEach(checkbox => {
            checkbox.setAttribute('tabindex', '0');
        });
    });

    function updateToggleLabel(toggle, selectedOptions) {
        if (selectedOptions.length > 1) {
            toggle.textContent = `${selectedOptions.length} items selected`;
        } else if (selectedOptions.length === 1) {
            toggle.textContent = selectedOptions[0];
        } else {
            toggle.textContent = 'Select an option to filter';
        }
    }

    function checkSelectedOptions(menu, selectedOptions) {
        const checkboxes = menu.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            if (selectedOptions.includes(checkbox.value)) {
                checkbox.checked = true;
                const optionElement = checkbox.closest('li[role="option"]');
                if (optionElement) {
                    optionElement.setAttribute('aria-checked', 'true');
                }
            }
        });
    }

    function toggleDropdown(toggle, menu) {
        const expanded = toggle.getAttribute('aria-expanded') === 'true' || false;
        toggle.setAttribute('aria-expanded', !expanded);
        menu.classList.toggle('show');
        
        // If opening the dropdown, focus the first checkbox directly
        if (!expanded) {
            const firstCheckbox = menu.querySelector('input[type="checkbox"]');
            if (firstCheckbox) {
                setTimeout(() => firstCheckbox.focus(), 10);
            }
        }
    }

    function closeDropdown(toggle, menu) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('show');
    }
});

let last_footnote = '';
jq(document).ready(function() {
    setTimeout(() => {
         // Convert brackets to superscripts
        function convertBracesToSuperscript(text) {
            return text.replace(/\{\{([^}]+)\}\}/g, '<sup>$1</sup>');
        }
        
        const contents = document.querySelectorAll('h1, h2, h3, h4, th');
        if (contents) {
            contents.forEach((content) => {
                content.innerHTML = convertBracesToSuperscript(content.innerHTML);
            });
        }
        // Check if the page contains the specified headings
        if (jq('.heading--h1:contains("Press Releases")').length || jq('.heading--h1:contains("News")').length) {
            return;
        }
        
        jq('h2 sup, h3 sup, .heading--h3 sup, li sup, p sup, .stat sup, th.label sup, .content-table th sup').each(function(index) {
            var supElement = jq(this);
            var footnoteNumber = supElement.text(); // Get the content of the sup element
            var uniqueSuffix = '-' + index; // Create a unique suffix using the index
            var footnoteId = 'footnote-' + footnoteNumber;
            var supId = 'sup-' + footnoteNumber + uniqueSuffix;
            
            // Assign a unique id to the sup element if it doesn't already have one
            if (!supElement.attr('id')) {
                supElement.attr('id', supId);
            }
            supElement[0].addEventListener('click', () => {
                last_footnote = supElement.attr('id');
            });
            
            // Find the corresponding footnote li element based on the number and assign a unique id to it
            var footnoteElement = jq('.footnotes ol li, .footnotes ul li').eq(footnoteNumber - 1);
    
            // Wrap the content of the footnote li in a p tag with a back link
            if (!footnoteElement.children('p').length) {
                footnoteElement.html('<p id="' + footnoteId + '" class="footnote-desc">' +
                    '<a href="#' + supId + '" class="footnote-return" aria-label="Back to Footnote ' + footnoteNumber + ' reference">' + footnoteNumber + '</a>. ' + footnoteElement.html() + 
                    '</p>');
            }
    
            // Create the anchor link for the sup element to point to the footnote
            supElement.wrap('<a class="footnote-anchor smooth-scroll" href="#' + footnoteId + '" aria-describedby="' + footnoteId + '" tabindex="0" data-footnote="' + footnoteId + '"></a>');
        });
    
        let footnote_section = document.querySelector('.footnotes .text');
        if (footnote_section) {
            let button = document.createElement('button');
            let arrow = document.createElement('span');
            button.classList.add('footnote-back-btn');
            button.setAttribute('aria-label', 'Back to content');
            arrow.classList.add('up-arrow');
            // Add tabindex="-1" to all li elements in the footnotes section
            jq('.footnotes li').each(function() {
                if (!jq(this).attr('tabindex')) {
                    jq(this).attr('tabindex', '-1');
                }
            });
            /*
            link with arrow icon - this script is created to mimic their site
            button.append(arrow);
            footnote_section.append(button);
            button.addEventListener('click', () => {
                if (last_footnote) {
                    let note_link = document.getElementById(last_footnote);
                    if (note_link) {
                        note_link.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        location.hash = last_footnote; // Update the URL anchor
                    }
                }
            });
            */
            
        }
    }, 10);
});

// Adds `aria-selected="true"` to the selected <option> for improved accessibility
document.addEventListener('DOMContentLoaded', function() {
    const selectors = [
        document.querySelector('.eq-select.announcement-picker'),
        document.querySelector('#class_selector.dropdown-and-tabs-section'),
        document.querySelector('#year_selector.dropdown-and-tabs-section')
    ];

    selectors.forEach(selectElement => {
        if (selectElement) {
            // Initial setting of aria-selected
            updateAriaSelected(selectElement);

            // Update aria-selected on change
            selectElement.addEventListener('change', function() {
                updateAriaSelected(selectElement);
            });
        }
    });

    function updateAriaSelected(select) {
        // Set aria-selected="false" for all options and true for the selected one
        Array.from(select.options).forEach(option => {
            option.setAttribute('aria-selected', 'false');
        });

        // Set aria-selected="true" to the currently selected option
        const selectedOption = select.options[select.selectedIndex];
        selectedOption.setAttribute('aria-selected', 'true');
    }
});

// Display dialog when clicking on a unique link
document.addEventListener("DOMContentLoaded", function () {
    const fragment = window.location.hash;

    if (fragment === "#investor-form" || fragment === "#borrower-form") {
        const dialogElement = document.querySelector(fragment);
        
        // Initialize EqDialog instance if it isn't already
        const eqDialog = new EqDialog();
        eqDialog.init();

        // Trigger the dialog to open
        if (dialogElement) {
            eqDialog.open("inline", fragment.substring(1));
        }
    }
    
    // Add keyboard navigation for sort buttons
    const sortButtons = document.querySelectorAll('.sort-button');
    sortButtons.forEach(button => {
        button.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.click();
            }
        });
    });
});

// Handle focus management for companies table filter form submission
jq(document).ready(function() {
    // Check if we have a hash in the URL that indicates a filter was applied
    if (window.location.hash === '#company_table') {
        // Find the companies data table and set focus to it
        const companiesTable = document.getElementById('companies-data-table');
        if (companiesTable) {
            // Check if cookie consent banner is visible
            const cookieConsentBanner = document.getElementById('cookie-consent-banner');
            const isCookieBannerVisible = cookieConsentBanner && cookieConsentBanner.style.display !== 'none';
            
            // Use a longer timeout if cookie banner is visible to ensure our focus takes precedence
            const timeoutDelay = isCookieBannerVisible ? 600 : 200;
            
            // Use setTimeout to ensure the page has fully loaded and other scripts have run
            setTimeout(() => {
                companiesTable.focus();
                // Scroll the table into view with 250px offset
                const elementPosition = companiesTable.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - 250;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }, timeoutDelay);
        }
    }
});

// focus thank you message on contact form submission
jq(document).ready(function() {
    if (document.querySelector('.thank-you-focus')) {
        const thankYouFocus = document.querySelector('.thank-you-focus');
        thankYouFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        thankYouFocus.focus();
    }
});